"use strict";
exports.__esModule = true;
exports.RoomSummaryType = exports.RoomServicesType = exports.RoomTemplateImage = exports.RoomDefaultLabel = void 0;
var RoomDefaultLabel;
(function (RoomDefaultLabel) {
    RoomDefaultLabel["NoPrice"] = "--";
    RoomDefaultLabel["NoAvailability"] = "NO AVAILABILITY";
})(RoomDefaultLabel = exports.RoomDefaultLabel || (exports.RoomDefaultLabel = {}));
var RoomTemplateImage;
(function (RoomTemplateImage) {
    RoomTemplateImage["AvailproBookingEnginesPreview"] = "Availpro-BookingEngines-Preview";
    RoomTemplateImage["BookingEngineCarousel"] = "BookingEngine-Carousel";
    RoomTemplateImage["BookingEngineDetails"] = "BookingEngine-Details";
    RoomTemplateImage["BookingEngineHotelThumbnail"] = "BookingEngine-HotelThumbnail";
    RoomTemplateImage["BookingEngineResultThumbnail"] = "BookingEngine-ResultThumbnail";
    RoomTemplateImage["BookingEngineWide"] = "BookingEngine-Wide";
    RoomTemplateImage["ConfirmationImageHotel"] = "Confirmation_Image_Hotel";
    RoomTemplateImage["ConfirmationImageHotel2x"] = "Confirmation_Image_Hotel@2x";
    RoomTemplateImage["Display"] = "Display";
    RoomTemplateImage["Large"] = "Large";
    RoomTemplateImage["Medium"] = "Medium";
    RoomTemplateImage["Original"] = "Original";
    RoomTemplateImage["Small"] = "Small";
    RoomTemplateImage["SmartGalleryPreview"] = "Smart_Gallery_Preview";
    RoomTemplateImage["SmartImageZoom"] = "Smart_Image_Zoom";
    RoomTemplateImage["SmartPackagePrincipal"] = "Smart_Package_Principal";
    RoomTemplateImage["SmartRoomPrincipal"] = "Smart_Room_Principal";
    RoomTemplateImage["TouchImageExtra"] = "Touch_Image_Extra";
    RoomTemplateImage["TouchImageExtra2x"] = "Touch_Image_Extra@2x";
    RoomTemplateImage["TouchImageGallery"] = "Touch_Image_Gallery";
    RoomTemplateImage["TouchImageGallery2x"] = "Touch_Image_Gallery@2x";
    RoomTemplateImage["TouchImageHotel"] = "Touch_Image_Hotel";
    RoomTemplateImage["TouchImageHotel2x"] = "Touch_Image_Hotel@2x";
    RoomTemplateImage["TouchImageRate"] = "Touch_Image_Rate";
    RoomTemplateImage["TouchImageRate2x"] = "Touch_Image_Rate@2x";
    RoomTemplateImage["TouchImageRoom"] = "Touch_Image_Room";
    RoomTemplateImage["TouchImageRoom2x"] = "Touch_Image_Room@2x";
    RoomTemplateImage["TouchImageRoomRate"] = "Touch_Image_RoomRate";
    RoomTemplateImage["TouchImageRoomRate2x"] = "Touch_Image_RoomRate@2x";
    RoomTemplateImage["UserPictureDetails"] = "UserPicture-Details";
    RoomTemplateImage["UserPictureThumbnail"] = "UserPicture-Thumbnail";
    RoomTemplateImage["XLarge"] = "XLarge";
})(RoomTemplateImage = exports.RoomTemplateImage || (exports.RoomTemplateImage = {}));
var RoomServicesType;
(function (RoomServicesType) {
    RoomServicesType["General"] = "General";
    RoomServicesType["Bathroom"] = "Bathroom";
    RoomServicesType["Appliances"] = "Appliances";
})(RoomServicesType = exports.RoomServicesType || (exports.RoomServicesType = {}));
var RoomSummaryType;
(function (RoomSummaryType) {
    RoomSummaryType["Html"] = "Html";
    RoomSummaryType["PlainText"] = "PlainText";
})(RoomSummaryType = exports.RoomSummaryType || (exports.RoomSummaryType = {}));
//# sourceMappingURL=room.interface.js.map